import { memo, useEffect } from "react";
import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { RegionService } from "../../services/RegionService";
import { mdlRegionSubListRequest } from "../../models/service-models/region/RegionSubListRequest";
import { mdlLanguage } from "../../models/ui-models/Language";

export type SubRegionSelectProps = {
    onChange?: Function;
    selectedLanguage?: mdlLanguage;
    parentRegionId?: string;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
}

export const SubRegionSelect = (props: SubRegionSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (props.parentRegionId){
            refetch();
        }
    }, []);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getRegion",props.parentRegionId],
        () => {
            return RegionService.SubList({ parentRegionId: props.parentRegionId, currentLanguage: props.selectedLanguage?.value } as mdlRegionSubListRequest);
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!props.parentRegionId
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    let countries = data?.body?.data;

    return (
        <>
            <Select
                mode={props.mode}
                loading={isLoading}
                onFocus={onFocus}
                size="middle"
                value={props.mode == "multiple" ? props.value as string[] : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseRegion")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={countries?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
}